module.exports = __webpack_public_path__ + "images/users/opt_in_modal/content-bg_3be5c89505bb3ecca7fda6375a51de87.png";